export default {
  singleLabel: "Groupe d'entreprises",
  storeNamespace: 'company_group',
  authFeature: 'company-group',
  listRouteName: "CompanyGroupList",
  newRouteName: "CompanyGroupNew",
  editRouteName: "CompanyGroupEdit",
  detailRouteName: "CompanyGroupDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'CompanyGroupForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'name',
  sortBy: 'name',
  showExtendedFilters: true,
  fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      name: 'code',
      label: "Code",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/CompanyGroup/config.js